import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _countLikesRequest = {};
var _countLikesResponse = {};
var _createLikeRequest = { like: '_like' };
var _createLikeResponse = { like: '_like' };
var _deleteLikeByFqdnAndEntityIdRequest = {};
var _deleteLikeByFqdnAndEntityIdResponse = {};
var _deleteLikeRequest = {};
var _deleteLikeResponse = {};
var _getLikeByFqdnAndEntityIdRequest = {};
var _getLikeByFqdnAndEntityIdResponse = { like: '_like' };
var _getLikeRequest = {};
var _getLikeResponse = { like: '_like' };
var _like = { createdDate: 'google.protobuf.Timestamp' };
var _queryLikesRequest = {};
var _queryLikesResponse = { likes: '_like' };
function resolveWixBlogV1LikeServiceUrl(opts) {
    var domainToMappings = {
        _: [
            {
                srcPath: '/_api/blog-like-service',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/blog-like-service',
                destPath: '',
            },
        ],
        'social-blog._base_domain_': [
            {
                srcPath: '/_api/blog-like-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Creates a like. */
export function createLike(payload) {
    var _a = serializer(_createLikeRequest, {
        _like: _like,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createLikeResponse, { _like: _like }).fromJSON;
    function __createLike(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v1.like',
            method: 'POST',
            methodFqn: 'wix.blog.v1.LikeService.CreateLike',
            url: resolveWixBlogV1LikeServiceUrl({
                protoPath: '/v1/likes',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createLike.fromReq = fromReq;
    __createLike.__isAmbassador = true;
    return __createLike;
}
/** Retrieves a like. */
export function getLike(payload) {
    var _a = serializer(_getLikeRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getLikeResponse, { _like: _like }).fromJSON;
    function __getLike(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v1.like',
            method: 'GET',
            methodFqn: 'wix.blog.v1.LikeService.GetLike',
            url: resolveWixBlogV1LikeServiceUrl({
                protoPath: '/v1/likes/{likeId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getLike.fromReq = fromReq;
    __getLike.__isAmbassador = true;
    return __getLike;
}
/** Retrieves a like by fqdn and entityId. */
export function getLikeByFqdnAndEntityId(payload) {
    var _a = serializer(_getLikeByFqdnAndEntityIdRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getLikeByFqdnAndEntityIdResponse, {
        _like: _like,
    }).fromJSON;
    function __getLikeByFqdnAndEntityId(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v1.like',
            method: 'GET',
            methodFqn: 'wix.blog.v1.LikeService.GetLikeByFqdnAndEntityId',
            url: resolveWixBlogV1LikeServiceUrl({
                protoPath: '/v1/likes/fqdn/{fqdn}/entity-id/{entityId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getLikeByFqdnAndEntityId.fromReq = fromReq;
    __getLikeByFqdnAndEntityId.__isAmbassador = true;
    return __getLikeByFqdnAndEntityId;
}
/**
 * Retrieves a list of likes, given the provided [paging, filtering, and sorting][1].
 *
 * Up to 100 likes can be returned per request.
 *
 * To learn how to query likes, see [API Query Language][2].
 *
 * [1]: https://dev.wix.com/api/rest/getting-started/sorting-and-paging
 * [2]: https://dev.wix.com/api/rest/getting-started/api-query-language
 */
export function queryLikes(payload) {
    var _a = serializer(_queryLikesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryLikesResponse, { _like: _like }).fromJSON;
    function __queryLikes(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v1.like',
            method: 'POST',
            methodFqn: 'wix.blog.v1.LikeService.QueryLikes',
            url: resolveWixBlogV1LikeServiceUrl({
                protoPath: '/v1/likes/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryLikes.fromReq = fromReq;
    __queryLikes.__isAmbassador = true;
    return __queryLikes;
}
export function countLikes(payload) {
    var _a = serializer(_countLikesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_countLikesResponse, {}).fromJSON;
    function __countLikes(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v1.like',
            method: 'POST',
            methodFqn: 'wix.blog.v1.LikeService.CountLikes',
            url: resolveWixBlogV1LikeServiceUrl({
                protoPath: '/v1/likes/count',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __countLikes.fromReq = fromReq;
    __countLikes.__isAmbassador = true;
    return __countLikes;
}
/** Deletes a like. */
export function deleteLike(payload) {
    var _a = serializer(_deleteLikeRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteLikeResponse, {}).fromJSON;
    function __deleteLike(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v1.like',
            method: 'DELETE',
            methodFqn: 'wix.blog.v1.LikeService.DeleteLike',
            url: resolveWixBlogV1LikeServiceUrl({
                protoPath: '/v1/likes/{likeId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteLike.fromReq = fromReq;
    __deleteLike.__isAmbassador = true;
    return __deleteLike;
}
/** Deletes a like by FQDN and entity_id. */
export function deleteLikeByFqdnAndEntityId(payload) {
    var _a = serializer(_deleteLikeByFqdnAndEntityIdRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteLikeByFqdnAndEntityIdResponse, {}).fromJSON;
    function __deleteLikeByFqdnAndEntityId(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v1.like',
            method: 'DELETE',
            methodFqn: 'wix.blog.v1.LikeService.DeleteLikeByFqdnAndEntityId',
            url: resolveWixBlogV1LikeServiceUrl({
                protoPath: '/v1/likes/fqdn/{fqdn}/entity-id/{entityId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteLikeByFqdnAndEntityId.fromReq = fromReq;
    __deleteLikeByFqdnAndEntityId.__isAmbassador = true;
    return __deleteLikeByFqdnAndEntityId;
}
//# sourceMappingURL=http.impl.js.map